import React from 'react';
import { Box } from '@mui/material';

interface LogoProps {
  size?: number;
  color?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 40, color = '#255E5E' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background circle */}
        <circle cx="20" cy="20" r="18" fill={color} opacity="0.1" />

        {/* Multiple patients - representing lead management */}
        {/* Patient 1 */}
        <circle cx="14" cy="15" r="3" fill={color} />
        <path d="M9 26C9 23 11 21 14 21C17 21 19 23 19 26V28H9V26Z" fill={color} />

        {/* Patient 2 - center/main */}
        <circle cx="20" cy="13" r="3.5" fill={color} />
        <path d="M13 28C13 24 16 21 20 21C24 21 27 24 27 28V30H13V28Z" fill={color} />

        {/* Patient 3 */}
        <circle cx="26" cy="15" r="3" fill={color} />
        <path d="M21 26C21 23 23 21 26 21C29 21 31 23 31 26V28H21V26Z" fill={color} />

        {/* Connecting line representing lead flow */}
        <path
          d="M17 21L23 21"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          opacity="0.6"
        />
      </svg>
    </Box>
  );
};

export default Logo;
